import { useState, useEffect, useMemo, ReactNode } from "react";
import { faCircleExclamation, faFile } from "@fortawesome/free-solid-svg-icons";
import { faCommentAlt } from "@fortawesome/pro-regular-svg-icons/faCommentAlt";
import { faDownload } from "@fortawesome/pro-regular-svg-icons/faDownload";
import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faKey } from "@fortawesome/pro-regular-svg-icons/faKey";
import { faMinusOctagon } from "@fortawesome/pro-regular-svg-icons/faMinusOctagon";
import { faFileCheck } from "@fortawesome/pro-solid-svg-icons/faFileCheck";
import { faUserMdChat } from "@fortawesome/pro-solid-svg-icons/faUserMdChat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@vapor/react-material/Button";
import Typography from "@vapor/react-extended/ExtendedTypography";
import Stack from "@vapor/react-material/Stack/";
import moment from "moment";
import Popover from "@vapor/react-material/Popover";
import { Link, useNavigate } from "react-router-dom";
import { macroCategoryCostants, macroCategoryConstant } from "../../common-components/CostantStrings";
import {
  StyledCommentCount,
  StyledDivWrapper,
  StyledFileIconContainer,
  StyledFlexWrapper,
  StyledGreyBoxContainer,
  StyledInboxIconContainer,
  StyledSliceCard,
} from "../document-styled-components/CardListStyles";
import { useDownloadDocument } from "../hooks/api-hooks/useDownloadADocument";
import { useAuth, useTranslation } from "@onefront/react-sdk";
import { usePost } from "@onefront/react-sdk";
import useFormatDocumentName from "../../common-utils/useFormatDocumentName";
import { useLocation } from "react-router-dom";
/////////////

import Drawer from "@vapor/react-material/Drawer";
import * as React from 'react';
import Box from '@vapor/react-material/Box';
import { Chat } from "@onefront/documents-smart-components/src/dumb/Chat/Chat";
import { buildHeaders } from "../../common-utils/buildHeaders";
import { config } from "../../../config";
import { v4 as uuidv4, v4 } from "uuid";
import Tooltip from "@vapor/react-material/Tooltip";
interface sliceCard {
  doc: any;
  workspaceId: string;
}

type Anchor = 'right';

export function TemporaryDrawer(props: { children: ReactNode, for: ReactNode }) {
  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });
      };


  return (
    <div>
      <React.Fragment key={'right'}>
        <div style={{ cursor: "pointer" }} onClick={toggleDrawer('right', true)}>{props.for}</div>
        <Drawer
          width={500}
          anchor={'right'}
          open={state['right']}
          onClose={toggleDrawer('right', false)}
        >
          <div style={{ margin: 10, marginTop: 80 }}>
            {props.children}
          </div>
        </Drawer>
      </React.Fragment>
    </div>
  );
}
function ExperimentalFeatureWrapper(props: { children: ReactNode }) {
  return config.documentExperimentalFeature ? props.children : undefined;
}

function AiResponseContainer(props: { children: ReactNode, doc: any }) {
  const [sendingMessage, setSendingMessage] = useState<any>()
  const [messages, setMessages] = useState<any[]>([
    {
      message: "Benvenuto, sono il tuo AI assistant. Hai bisogno di informazioni sul documento?",
      authorId: "AI Assistant", authorName: "Ai Assistant", date: new Date(), messageId: v4(), messageType: "normal", clientId: "123", received: true,
      loaded: true
    },
  ])
  const authData = undefined
  const { data, loading, hasLoaded, fetch, error } = usePost(
    `documentsApi://api/v1/ai/${props.doc.documentId}`,
    {
      message: messages.slice(-1)[0].message,
    },
    {
      headers: {
        "X-App-Version": 1,
        "X-App-Name": 1,
        "X-Correlation-Id": uuidv4(),
        "X-Forwarded-For": "frontend",
        "X-Request-Id": uuidv4(),
        "X-User-Id": "name",
      },
    },
    { lazy: true }
  );
  useEffect(() => {
    if (sendingMessage?.message) fetch()
  }, [sendingMessage?.message])
  useEffect(() => {
    if (data?.message) {
      setSendingMessage({})
      setMessages([...messages,
      {
        message: data?.message,
        authorId: "Ai Assistant",
        authorName: "Ai Assistant",
        date: new Date(),
        messageId: v4(),
        messageType: "normal",
        clientId: "123",
        received: false,
        loaded: true
      }])
    }
  }, [data?.message])
  return <TemporaryDrawer for={props.children}>
    <Chat data={messages} usersData={[]} sendMessage={(chat: string) => {
      const message = {
        message: chat,
        authorId: "User",
        authorName: "User",
        date: new Date(),
        messageId: v4(),
        messageType: "normal",
        clientId: "123",
        received: false,
        loaded: false
      }
      setSendingMessage(message)
      setMessages([...messages, message])
    }} />
  </TemporaryDrawer>
}

const SliceCard = ({ doc, workspaceId }: sliceCard) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [documentType, setDocumentType] = useState<string>();
  const open = Boolean(anchorEl);
  const { t } = useTranslation("DOCS");
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const isEmbeded = query.get("embed");

  const isFatture = useMemo(() => doc?.einvoice === true, [doc]);

  const {
    data: download,
    fetch,
    hasLoaded,
  } = useDownloadDocument(
    doc.documentId,
    workspaceId,
    doc.fileName,
    documentType,
    isFatture
  );
  const date = moment(doc.createdOn).format("DD/MM/YYYY");
  const checkVisibility = doc.visibleByAccountantOnly;
  const checkIfEncrypted = doc.encrypted;
  const documentTitle = doc.title;
  const fileName = doc.fileName;
  const isInbox = (doc?.standardTags || []).some(
    (x: any) => x.value === "Inbox"
  );
  const macro = doc?.standardTags.filter(
    (val: any) => val.name === "macrocategory"
  )[0].value;


  const icon =
    macroCategoryConstant.get(macro) || macroCategoryCostants.tutti.icon;


  const documentSearchPercentageScore =
    doc?.documentSearchScorePercentage === "NaN"
      ? 0
      : doc?.documentSearchScorePercentage

  const documentSearchPercentage =
    documentSearchPercentageScore !== 0
      ? "Corrispondenza  " + doc?.documentSearchScorePercentage + "%"
      : 0;


  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: { currentTarget: any }) => {
    isFatture ? setAnchorEl(event.currentTarget) : setDocumentType("ASSOSW");
  };

  useEffect(() => {
    if (documentType === "ASSOSW" || documentType === " ") {
      fetch();
    }
  }, [documentType]);

  return (
    <>
      <StyledSliceCard key={doc.documentId}>
        <StyledDivWrapper>
          <Link
            to={`/document-details/${doc.documentId}/${workspaceId}${isEmbeded ? "?embed=true" : ""
              }`}
            style={{ textDecoration: "none", width: "100%" }}
          >
            <Stack direction={"row"}>
              {" "}
              <StyledInboxIconContainer>
                <FontAwesomeIcon
                  style={{
                    marginTop: "50%",
                    color: "#005075",
                  }}
                  fontSize={"24px"}
                  icon={icon}
                />
              </StyledInboxIconContainer>
              <div>
                {documentSearchPercentage ? (
                  <Typography
                    variant="caption"
                    marginBottom={1}
                    color={documentSearchPercentageScore > 80 ? "green" : "grey"}
                  >
                    {documentSearchPercentage}
                  </Typography>
                ) : (
                  <div style={{ marginTop: 25 }}></div>
                )}
                <Stack direction="row">
                  <Typography
                    fontSize={"20px"}
                    fontFamily={"Cairo"}
                    fontWeight={600}
                    color="#005075"
                    paddingRight="10px"
                  >
                    {useFormatDocumentName(documentTitle)}
                  </Typography>
                  <Stack direction="row" gap={1} alignItems="center">
                    {doc?.urgent && (
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        color="#D92B2C"
                      ></FontAwesomeIcon>
                    )}

                    {checkVisibility && (
                      <FontAwesomeIcon
                        color="red"
                        icon={faMinusOctagon}
                      />
                    )}
                    {checkIfEncrypted && (
                      <FontAwesomeIcon
                        color="red"
                        icon={faKey}
                      />
                    )}
                  </Stack>
                </Stack>
                <StyledFlexWrapper>
                  <div style={{ marginRight: "10px" }}>
                    <Typography variant="bodySmall">
                      {t("document.file.uploadDate")}:{" "}
                    </Typography>
                    <Typography variant="bodySmall" fontWeight={"bold"}>
                      {date}
                    </Typography>
                  </div>
                  {!isInbox && (
                    <div>
                      <Typography variant="bodySmall">
                        {t("classification.fileName")}:
                      </Typography>
                      <Typography fontWeight={"bold"} variant="bodySmall">
                        {" "}
                        {fileName || ""}
                      </Typography>
                    </div>
                  )}
                </StyledFlexWrapper>
              </div>
            </Stack>
          </Link>

          <StyledFlexWrapper>
            <StyledFileIconContainer>
              <ExperimentalFeatureWrapper>
                <AiResponseContainer doc={doc}>
                  <FontAwesomeIcon icon={faUserMdChat} color={"#04567c"} style={{ marginLeft: 10 }}></FontAwesomeIcon>
                </AiResponseContainer>
              </ExperimentalFeatureWrapper>
            </StyledFileIconContainer>
            <StyledFileIconContainer>
              <FontAwesomeIcon
                icon={doc.read ? faFileCheck : faFile}
                color={doc.userType === "ACCOUNTANT" ? "#152935" : "#0177ac"}
              ></FontAwesomeIcon>
            </StyledFileIconContainer>
            <StyledGreyBoxContainer>
              <Tooltip title={t("document.openComments")} placement="top" arrow>
              <Button
                onClick={() =>
                  navigate(
                    `/document-details/${doc.documentId}/${workspaceId}${isEmbeded ? "?embed=true" : ""
                    }`
                  )
                }
              >
                <StyledCommentCount>
                  {doc.notesCount > 100 ? "99+" : doc.notesCount}
                </StyledCommentCount>
                  <FontAwesomeIcon
                    color="#0090d1"
                    size="lg"
                    icon={faCommentAlt}
                  />
              </Button>
                </Tooltip>
              <Tooltip placement="top" title={t("document.preview")} arrow>
                <Button>
                  <FontAwesomeIcon
                    color="#0090d1"
                    size="lg"
                    icon={faEye}
                    onClick={() => {
                      navigate(
                        `/document-details/${doc.documentId}/${workspaceId}${isEmbeded ? "?embed=true" : ""
                        }`
                      );
                    }}
                  />
                </Button>
              </Tooltip>
              <Tooltip
                arrow
                placement="top"
                title={t("document.download")}
              >
                <Button>
                  <FontAwesomeIcon
                    onClick={handleClick}
                    size="lg"
                    key={doc.documentId}
                    color="#0090d1"
                    icon={faDownload}
                  />
                </Button>
              </Tooltip>
              {isFatture && (
                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <Typography
                    sx={{
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                    margin={2}
                    onClick={() => {
                      setDocumentType("ASSOSW");
                    }}
                  >
                    {t("document.downloadPdf")}
                  </Typography>
                  <Typography
                    sx={{
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                    margin={2}
                    onClick={() => {
                      setDocumentType(" ");
                    }}
                  >
                    {t("document.downloadXml")}
                  </Typography>
                </Popover>
              )}
            </StyledGreyBoxContainer>
          </StyledFlexWrapper>
        </StyledDivWrapper>
      </StyledSliceCard>
    </>
  );
};

export default SliceCard;
